<div class="row">
  <div class="col-12" [class.mobile]="'MOBILE' | isViewMode | async">
    <div class="ck-content ck" [innerHTML]="safeHTML"></div>
  </div>
</div>